// extracted by mini-css-extract-plugin
export default {"contacts":"contacts--TVEP","contact":"contact--43Ra","label":"label--k7GM"};